<template>
    <div class="row" :id="table_id">
        <div class="col-12 main-data-table-container">
            <table class="table table-striped main-data-table">
                <thead class="main-thead">
                    <tr class="headers" style="text-align: center; cursor: pointer;">
                        <datatables-header-column-component 
                            v-for="header in headers"
                            :key="header.key"
                            :col_key="header.key"
                            :class="header.head_classes"
                            :text="header.trans"
                            :sorting_key="sorting_key"
                            :sorting_direction="sorting_direction"
                        />
                    </tr>
                    <tr v-if="filter_header" class="filters">
                        <th v-for="header in headers" :key="header.key" :class="[header.head_classes]">
                            <input type="text" class="form-control filter-input-sm"
                                v-if="header.filter_type == 'text'"
                                v-on:input="filterInput()"
                                v-model="filter_values[header.key]"
                            >
                            <input type="text" class="form-control filter-input-sm vue-datatables-dateranger-filter"
                                v-if="header.filter_type == 'date_range'"
                                :data-header-key="header.key"
                                v-model="filter_values[header.key]"
                            >
                            <select class="form-control select2_ajax" 
                                    :class="header.key + '_select2'"
                                    v-if="header.filter_type == 'select2_ajax'" 
                                    v-on:change="filterInput()"
                                    v-select2
                                    v-model="filter_values[header.key]"
                                    :data-url="header.filter_url"
                                    :data-additional="header.filterDataAdditional || '{}'"
                            ></select>

                            <select class="form-control filter-input-sm"
                                v-if="header.filter_type == 'simple_select'"
                                v-on:change="filterInput()"
                                v-model="filter_values[header.key]"
                            >
                                <option v-for="(option_value, option_index) in JSON.parse(Base64.decode(header.filterData)).options" 
                                    :key="option_index" 
                                    :value="option_index"
                                >
                                    {{ option_value }}
                                </option>
                            </select>
                        </th>
                    </tr>
                </thead>
                <tbody class="spinner" id="spinner">
                    <tr>
                        <td class="text-center" :colspan="headers.length">
                            <i class="fa fa-cog fa-spin fa-4x"></i>
                        </td>
                    </tr>
                </tbody>
                <tbody class="main-tbody" style="display: none;">
                    <tr v-for="(row, row_index) in table_data[current_page]" :key="row_index">
                        <td v-for="(header, header_index) in headers"
                            :key="header_index"
                            :col_key="header.key"
                            :class="[header.cell_classes]"
                            v-html="row[header.key]">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12" :id="`${table_id}_pagination`">
            <nav>
                <ul class="pagination justify-content-center">
                    <li v-if="current_page == 1" class="page-item disabled" aria-disabled="true" aria-label="« First">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-fast-backward"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(1)" type="button" class="page-link"  aria-label="« First">
                            <i class="fa fa-fast-backward" style="color: black;"></i>
                        </button>
                    </li>

                    <li v-if="current_page == 1" class="page-item disabled" aria-disabled="true" aria-label="« Previuos">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-backward"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(current_page-1)" type="button" class="page-link"  rel="prev" aria-label="« Previuos">
                            <i class="fa fa-backward" style="color: black;"></i>
                        </button>
                    </li>

                    <li class="page-item" v-for="(i, _) in [4, 3, 2, 1]" :key="`${_}-before`" v-show="current_page-i >= 1">
                        <button @click="changePage(current_page-i)" type="button" class="page-link">{{ current_page-i }}</button>
                    </li>

                    <li class="page-item active">
                        <button type="button" class="page-link">{{ current_page }}</button>
                    </li>

                    <li class="page-item" v-for="(i, _) in [1, 2, 3, 4]" :key="`${_}-after`" v-show="current_page+i <= page_count">
                        <button @click="changePage(current_page+i)" type="button" class="page-link">{{ current_page+i }}</button>
                    </li>

                    <li v-if="current_page >= page_count" class="page-item disabled" aria-disabled="true" aria-label="Next »">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-forward"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(current_page+1)" type="button" class="page-link" rel="next" aria-label="Next »">
                            <i class="fa fa-forward" style="color: black;"></i>
                            </button>
                    </li>

                    <li v-if="current_page >= page_count" class="page-item disabled" aria-disabled="true" aria-label="Last »">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-fast-forward"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(page_count)" type="button" class="page-link" aria-label="Last »">
                            <i class="fa fa-fast-forward" style="color: black;"></i>
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            'headers': [],
            'filter_values': {},
            'table_data': {},
            'current_page': 1,
            'per_page': 20,
            'request_number': 1,
            'header_keys': [],
            'page_count': 1,
            'loaded_pages': [],
            'sorting_key': '',
            'sorting_dir': '',
            'filter_timer': null,
        }
    },
    props: {
        'table_id': {
            'type': String,
            'required': true,
        },
        'sort_key': {
            'type': String,
            'required': false,
            'default': 'id'
        },
        'sort_dir': {
            'type': String,
            'required': false,
            'default': 'asc',
        },
        'headers_json': {
            'type': String,
            'required': true,
        },
        'filter_header': {
            'type': Boolean,
            'required': false,
            'default': false,
        },
        'data_url': {
            'type': String,
            'required': true,
        },
        'non_sorting': {
            'type': Array,
            'required': false,
            'default': function(){
                return [];
            },
        },
        'edit_url': {
            'type': String,
            'required': false,
            'default': '#',
        },
        'destroy_url': {
            'type': String,
            'required': false,
            'default': '#',
        },
    },
    created: function(){
        let vue = this;

        vue.headers = JSON.parse(Base64.decode(vue.headers_json));

        vue.sorting_key = vue.sort_key;
        vue.sorting_direction = vue.sort_dir;

        $.each(vue.headers, function(index, element){
            vue.header_keys.push(element['key']);
        });

        vue.$nextTick(function () {
            let items = $('.vue-datatables-dateranger-filter');

            let complete_locale = window.daterangepicker_locales[window.locale];
            complete_locale['format'] = 'YYYY-MM-DD';

            items.daterangepicker({
                'locale': complete_locale,
                'linkedCalendars': false,
            });

            items.on('apply.daterangepicker', function () {
                vue.filter_values[$(this).data('header-key')] = $(this).val();
                vue.filterInput();
            });

            items.on('cancel.daterangepicker', function () {
                vue.filter_values[$(this).data('header-key')] = null;
                vue.filterInput();
            });

            items.attr('autocomplete', 'off');
        });

        vue.completeDataRefresh();
    },
    methods: {
        sortCol(col_key){
            let vue = this;

            if(vue.non_sorting.includes(col_key)){
                return;
            }

            if(vue.sorting_key == col_key){
                vue.sorting_direction = (vue.sorting_direction == 'desc' ? 'asc' : 'desc');
            } else{
                vue.sorting_direction = 'asc'
            }

            vue.sorting_key = col_key;
            vue.completeDataRefresh();
        },
        filterInput(){
            let vue = this;

            if(vue.filter_timer){
                clearTimeout(vue.filter_timer);
                vue.filter_timer = null;
            }

            vue.filter_timer = setTimeout(function(){
                vue.completeDataRefresh();
            }, 100);
        },
        completeDataRefresh(){
            let vue = this;

            vue.current_page = 1;
            vue.table_data = {};
            vue.loaded_pages = [];

            vue.loadCurrentPage();
        },
        loadCurrentPage(){
            let vue = this;

            if(vue.loaded_pages.includes(vue.current_page)){
                $('.main-tbody').show();
                $('.spinner').hide();
                return;
            }

            vue.request_number++;

            let request_data = {
                'request_number': vue.request_number,
                'sort_key': vue.sorting_key,
                'sort_dir': vue.sorting_direction,
                'page': vue.current_page,
                'per_page': vue.per_page,
                'columns': vue.header_keys,
                'filters': vue.filter_values,
            };

            axios.post(vue.data_url, request_data)
            .then(function(response){
                if(response.data.request_number != vue.request_number){
                    return;
                }

                vue.current_page = parseInt(response.data.page);
                vue.page_count = parseInt(response.data.total_pages);

                if(response.data.table_data.length > 0){
                    vue.table_data[vue.current_page] = response.data.table_data;
                    vue.loaded_pages.push(response.data.page);
                }

                $('.main-tbody').show();
                $('.spinner').hide();

                vue.$forceUpdate();
            })
            .catch(function(error){
                console.error(error);
            });

        },
        changePage(new_page){
            let vue = this;
            if(new_page < 0 || new_page > vue.total_pages || new_page == vue.current_page){
                return;
            }

            vue.current_page = new_page;
            vue.loadCurrentPage();
        },
    
    }
}
</script>
